import { readCookie, setCookie, getCookie, createCookie, eraseCookie, deleteCookie } from '../Utility/CookieManager.js';
import {  rcmg_api_call } from '../RCMG_V2/RcmgCommon.js';

function promo_init() {
    
    $(document).ready(function () {

       show_promo_modal();
        
    });
}

function show_promo_modal (){
    var product_type = readCookie('rcmg_product_type');
    var is_ad_free = parseInt(readCookie('evaf'));
    
    /*
    * Only register this event if user is logged in and is adfree and is using our legacy producty tyep
    * */

    if (!readCookie('rcmg_legacy_upgrade_prompted_displayed') && product_type == 'realclear' &&  is_ad_free == 1 ) {
        
        window.document.addEventListener("scroll", show_promo_modal);

        if(document.body.scrollTop > 200 || document.documentElement.scrollTop > 200){

            if(product_type == 'realclear' &&  is_ad_free == 1  ){ //realclear ptoduct type is the legacy product type 

                load_promo_modal();

                $('.promo-modal').show();
                $('.modal-backdrop').show();

                promo_handlers();
                window.document.removeEventListener("scroll", show_promo_modal);

                createCookie('rcmg_legacy_upgrade_prompted_displayed', true, 30 );

            }
            
        }
        
    }

    

}

function promo_handlers(){

    $(document).on('click', '.close-icon', function(){
        $('.promo-modal').hide();
        $('.modal-backdrop').hide();
        //set a cookie to for 30 days to not display it
    });

    $(document).on('click','.no-thanks', function(){
        $('.promo-modal').hide();
        $('.modal-backdrop').hide();
        //set a cookie to for 30 days to not display it
    });

    $(document).on('click', '.accept-offer', function(){
        $('.modal-body').hide()
        $('.modal-footer').hide();

        var data = {
            'rcmg_guid' : readCookie('rcmg_guid')
        }


        rcmg_api_call('rcmg_user_account_upgrade',data, function(res){

            console.log(res);
            if(res.success){

                $('.submitted-form-message').show();

            }


        });


    });

}

function load_promo_modal(){
    var html = '<div class="modal-backdrop"></div>' +
        '<div class="promo-modal">' +
        '    <div class="left-side-modal">' +
        '        <div class="rcmg-logo"><img src="https://util.realclearpolitics.com/rcmg_users/assets/rcmg_logo.png"></div>' +
        '        <div class="close-icon">X</div>' +
        '    </div>' +
        '    <div class="right-side-modal">\n' +
        '        <div class="modal-body">' +
        '            <div class="modal-offer">' +
        '                <div class="heading">Upgrade Your Ad-Free Account</div>' +
        '                <div class="disclousure">Upgrade your ad-free account to include <b>RealClearPolitics</b> to your ad-free experience, <b>free for 12 months!</b> After your plan rate will move up to <b>$4.99</b> p/month or <b>$49.99</b> p/yr depending on your plan type.</div>' +
        '            </div>' +
        '        </div>' +
        '        <div class="modal-footer">' +
        '            <div class="btn accept-offer outline">Yes, Upgrade me</div>' +
        '            <div class="btn outline no-thanks">No Thanks</div>' +
        '        </div>' +
        '        <div class="submitted-form-message" style="display: none;">' +
        '            <div class="heading">Congratulations!</div>' +
        '            <div class="offer-accepted-message">Someone from our tech department will be in touch with you shortly.</div>' +
        '        </div>' +
        '    </div>' +
        '</div> <!--end of promo-modal-->' +
        '<!--Modal End-->';
    
    $('body').append(html);
}

export default promo_init();


